export default __webpack_public_path__ + "static/media/swap.7298058d.svg";